import { useNavigate } from "react-router-dom";
import Banner from "../../search/banner";
import AddMachineForm from "./addMachineForm";

const AddMachineInfo = () => {
  let navigate = useNavigate();
  return (
    <>
      <div>
        <div className="bg-[#F2F2F2]">
          <Banner
            path={
              <>
                <span onClick={() => navigate("/")} className="cursor-pointer">
                  HOME
                </span>
                {" > "} SIGN UP / COMPLETE THIS INFORMATION
              </>
            }
          />
        </div>
      </div>
      <AddMachineForm />
    </>
  );
};
export default AddMachineInfo;
